import React from "react";
import { Toggle } from "react-powerplug";
import { Modal } from "@govlaunch/core";
import { useSlate } from "slate-react";
import Button from "../Button";
import * as palette from "@govlaunch/palette";
import FocusOnMount from "../utils/FocusOnMount";
import { ELEMENT_YOUTUBE_VIDEO, EMPTY_CHILDREN } from "../../Element";
import { setOrInsertElement } from "../../buttonActions";
import Icon, { ICON_YOUTUBE_VIDEO } from "../Icon";

export default function InsertYoutubeVideoButton() {
  const editor = useSlate();

  return (
    <Toggle>
      {({ on, toggle }) => (
        <>
          <Modal
            isOpen={on}
            style={{
              boxShadow: "0 10px 40px 0 rgba(34, 35, 40, 0.2)",
              borderRadius: 4,
            }}
            onRequestClose={() => toggle()}
            appElement={document.body}
          >
            <FocusOnMount nextTick={false}>
              {({ innerRef }) => (
                <div
                  css={{
                    display: "inline-flex",
                    flexDirection: "row",
                    alignItems: "center",
                    width: "auto",
                    minWidth: 240,
                    height: 40,
                  }}
                >
                  <input
                    ref={innerRef}
                    placeholder="What's the YouTube address?"
                    spellCheck={false}
                    css={{
                      border: "none",
                      outline: "none",
                      backgroundColor: "transparent",
                      padding: 10,
                      width: "100%",
                      height: "100%",
                      color: palette.text,
                      "&::placeholder": {
                        color: palette.sealBlue,
                      },
                    }}
                    onKeyDown={(event) => {
                      const currentValue = event.target.value;
                      if (event.key === "Enter" && currentValue) {
                        event.preventDefault();
                        const videoId = getYoutubeId(currentValue);

                        if (!videoId) {
                          return;
                        }

                        const youtubeVideo = {
                          type: ELEMENT_YOUTUBE_VIDEO,
                          videoId,
                          videoUrl: currentValue,
                          ...EMPTY_CHILDREN,
                        };

                        setOrInsertElement(editor, youtubeVideo);

                        toggle();
                      }

                      if (event.key === "Escape") {
                        toggle();
                      }
                    }}
                  />
                </div>
              )}
            </FocusOnMount>
          </Modal>
          <Button
            onMouseDown={(event) => {
              event.preventDefault();
              // check for left click
              if (event.button === 0) {
                toggle();
              }
            }}
          >
            <Icon iconName={ICON_YOUTUBE_VIDEO} />
          </Button>
        </>
      )}
    </Toggle>
  );
}

/**
 * https://gist.github.com/takien/4077195#gistcomment-2184219
 * @param   {String} urlString
 * @returns {String}
 */
function getYoutubeId(urlString) {
  const urlAfterSplit = urlString.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);

  return undefined !== urlAfterSplit[2] ? urlAfterSplit[2].split(/[^0-9a-z_-]/i)[0] : null;
}
